import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { getDepartments } from "../store/actions/departmentActions";
import { Redirect } from 'react-router-dom';
import { Link } from "react-router-dom";

import moment from 'moment';
import LOADER from "../assets/images/loader.svg";
import { useHistory, useLocation } from 'react-router-dom';



import TopBar from "../components/TopBar";
import Sidebar from "../components/Sidebar";

import Meters from "../components/Meters/Meters";
import GeneralDashboard from "../components/Dashboards/General";
import DepartmentDashboard from "../components/Dashboards/Department";
import RiskDashboard from "../components/Dashboards/RiskDashboard";


import { resetGotoRiskDashboard } from "../store/actions/riskActions";
import { resetDepartmentDashboard } from "../store/actions/departmentActions";


import Select from 'react-select'



const customStyles = {
    control: (provided, state) => ({
        ...provided,
        borderColor: state.isFocused ? '#3b3b3b' : '#ccc',
        boxShadow: state.isFocused ? '0 0 0 1px #3b3b3b' : 'none',
        '&:hover': {
            borderColor: '#3b3b3b',
        },
        backgroundColor: '#EEF0ED',
        padding: 1,
        width: '250px',
        marginLeft: '10px',
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 999999999999, // Ensures the menu appears above other elements
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#3b3b3b' : state.isFocused ? '#EEF0ED' : 'white',
        color: state.isSelected ? 'white' : '#3b3b3b',
        '&:hover': {
            // backgroundColor: '#EEF0ED',
        },
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#3b3b3b',
    }),
};


function Dashboards(props) {

    const { token, departments, getDepartmentsFN, match, resetGotoRiskDashboardFN, resetDepartmentDashboardFN } = props;

    const history = useHistory();
    const location = useLocation();
    const departmentfromredirect = location.state?.departmentfromredirect;

    const departmentOptions = departments && departments.map(department => ({
        value: department.department_id,
        label: department.name
    }));

    useEffect(() => {
        if (departmentfromredirect) {

            //alert(departmentfromredirect);
            let departmentname = departments && departments.find(department => department.department_id === departmentfromredirect);
            setActiveDepartmentId(departmentfromredirect);
            setActiveDepartment(departmentname.name);
            resetDepartmentDashboardFN();
        }
    }, [departmentfromredirect]);

    //const departments = ["General", "Financial", "Marketing", "Pricing", "IT", "HR", "Project", "Management"];
    const [activeDepartment, setActiveDepartment] = useState("General");
    const [activeDepartmentId, setActiveDepartmentId] = useState(null);
    const [activeRiskId, setActiveRiskId] = useState(null);
    const [selectedDepartment, setSelectedDepartment] = useState(null); // New state for Select component


    useEffect(() => {
        //resetDepartmentDashboardFN();
        resetGotoRiskDashboardFN();
        getDepartmentsFN();
    }, []);

    useEffect(() => {
        if (match.params.id) {
            setActiveRiskId(match.params.id);
        }
    }, [match.params.id]);



    return token ? (

        <div className="flex flex-col w-full h-screen overflow-hidden bg-[#F6F8FA]">
            <TopBar className="fixed top-0 left-0 right-0 z-10" />
            <div className="flex flex-row w-full h-full">
                <Sidebar className="fixed top-0 left-0 h-screen pt-[64px] z-0" /> {/* Adjust the top to match TopBar height */}
                <div id="dashboard-content" className="flex flex-col w-full p-4 overflow-auto"
                > {/* Adjust the margin-left to match Sidebar width */}
                    <div className="flex flex-wrap w-full">
                        {activeDepartment !== "General" && <div className="flex items-center">

                            {activeRiskId &&

                                <button className={`flex-1 p-2 text-l w-32${activeDepartment === "General" ? 'font-bold bg-[#3b3b3b] text-white' : 'bg-transparent text-black'} transition duration-200 rounded-[5px] m-1`}>
                                    Risk {activeRiskId}
                                </button>

                            }
                            <button className={`flex-1 p-2 text-l w-32 ${activeDepartment === "General" && !activeRiskId ? 'font-bold bg-[#3b3b3b] text-white' : 'bg-transparent text-black border border-[#3b3b3b]'} transition duration-200 rounded-[5px] m-1`}

                                onClick={() => {
                                    setSelectedDepartment(null); // Reset the Select component

                                    setActiveDepartment("General"); setActiveDepartmentId('all'); setActiveRiskId(null); if (history.location.pathname !== '/dashboards') history.push('/dashboards')
                                }}
                            >
                                General
                            </button>
                            {departments.map((department, index) => (
                                <button
                                    key={index}
                                    className={`flex-1 p-2 text-l ${activeDepartment === department.name ? 'font-bold bg-[#3b3b3b] text-white' : 'bg-transparent text-black'} transition duration-200 rounded-[5px] m-1`}
                                    onClick={() => { setActiveDepartment(department.name); setActiveDepartmentId(department.department_id); setActiveRiskId(null); if (history.location.pathname !== '/dashboards') history.push('/dashboards') }}
                                >
                                    {department.name}
                                </button>
                            ))}

                            <Select
                                options={departmentOptions}
                                placeholder="Select a department"
                                onChange={(e) => {
                                    let actual_department = departments.find(department => department.department_id === e.value);
                                    setActiveDepartment(actual_department.name);
                                    setActiveDepartmentId(e.value);
                                    //getDepartmentsFN(e.value);
                                    setActiveRiskId(null);
                                    setSelectedDepartment(e); // Update the selected department
                                    if (history.location.pathname !== '/dashboards') history.push('/dashboards')
                                }}
                                styles={customStyles}
                                //value={departmentOptions.find(department => department.value === activeDepartment)}
                                value={selectedDepartment}
                            />

                        </div>}
                        <div className="flex-1"> {/* Ensured this div takes full height for alignment */}
                            {/* {activeDepartment === "General" && !match.params.id && <Meters mode="general" />} */}
                            {activeDepartment !== "General" && !match.params.id && <Meters mode="department" department_id={activeDepartmentId} />}
                            {match.params.id && <Meters mode="risk" risk_id={match.params.id} />}

                        </div>
                    </div>


                    {activeDepartment === "General" && !match.params.id && (
                        <div className="mx-auto w-full px-4 py-4">
                            {/* 4xl ≈ 64 rem.  Adjust to taste: max-w-5xl, max-w-[1000px], etc. */}
                            <GeneralDashboard />
                        </div>
                        )}                   
                         {activeDepartment !== "General" && !match.params.id && <DepartmentDashboard department_id={activeDepartmentId} />}
                    {match.params.id && <RiskDashboard match={match} />}

                </div>
            </div>
        </div >
    ) : <Redirect to="/login" />;

}

const mapStateToProps = (state) => {
    return {

        token: state.auth.token,
        departments: state.department.departments,



    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getDepartmentsFN: () => dispatch(getDepartments()),
        resetGotoRiskDashboardFN: () => dispatch(resetGotoRiskDashboard()),
        resetDepartmentDashboardFN: () => dispatch(resetDepartmentDashboard()),

    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(Dashboards);
